export default "__VITE_ASSET__Cg7Mgn1p__"